import React, { useMemo, useState, useEffect } from 'react';
import { Collapse, Icon, Tooltip } from 'antd';
import {
  Widget,
  MasterDetailForm,
  FormSubmitButton,
  FormatText,
  FormInput,
  CompositeView,
  GridView,
  SimpleView,
  FormSelect,
  FormContext,
} from '@digital/ui';
import * as Yup from 'yup';
import FormularioTabelaAvaliacao from './FormularioTabelaAvaliacao';
import {
  createSasFornecedorPainel,
  getAllSasFornecedorPainelComAvaliacoes,
  sasFornecedorPainel,
  sasFornecedorAvaliacoes,
  sasFornecedorFrom,
  updateFornecedorPainel,
} from '@app/api/sas/sasFornecedor';
import { isValidGuid } from '@app/helpers/geradorGuid';
import {
  createsasFornecedorAvaliacaoCompliance,
  deletesasFornecedorAvaliacaoCompliance,
  downloadArquivoAnexoFornecedorAvaliacaoCompliance,
  sasFornecedorAvaliacaoComplianceFrom,
  viewArquivoAnexoFornecedorAvaliacaoCompliance,
} from '@app/api/sas/sasFornecedorAvaliacaoCompliance';
import {
  createSasFornecedorAvaliacaoFinanceira,
  deletesasFornecedorAvaliacaoFinanceira,
  downloadArquivoAnexoFornecedorAvaliacaoFinanceira,
  sasFornecedorAvaliacaoFinanceiraFrom,
  wiewArquivoAnexoFornecedorAvaliacaoFinanceira,
} from '@app/api/sas/sasFornecedorAvaliacaoFinanceira';
import {
  createsasFornecedorAvaliacaoConfide,
  deletesasFornecedorAvaliacaoConfide,
  downloadAnexoFornecedorAvaliacaoConfide,
  wiewArquivoAnexoFornecedorAvaliacaoConfide,
} from '@app/api/sas/sasFornecedorAvaliacaoConfide';
import { hasPermission } from '@app/helpers/permissions';
import { validarCNPJ } from '@app/helpers/validators';
import { vtStringToBoolean } from '@app/helpers/stringHelper';
import { Visibility } from '@app/components';
import { isObjNotEmpty } from '@app/helpers/objHelper';

const { Panel } = Collapse;

const FormFornecedor = () => {
  const params = new URLSearchParams(location.search);
  const [fornecedorId, setFornecedorId] = useState<string>("");
  const [fornecedorAvaliacoes, setFornecedorAvaliacoes] = useState<sasFornecedorPainel>({
    razaoSocial: "",
    cnpj: ""
  } as sasFornecedorPainel);
  const fornecedorIdParamentro = isValidGuid(params.get('id') || '') ? params.get('id') : null;
  const [fecharModalSucesso, setFecharModalSucesso] = useState<boolean>(false);

  const [ehInternacional, setEhInternacional] = useState(false);
  const [validationSchema, setValidationSchema] = useState<any>();

  useEffect(() => {
    if (fornecedorIdParamentro != null) {
      setFornecedorId(fornecedorIdParamentro);
      hasGetAllSasFornecedorComAvaliacoes(fornecedorIdParamentro);
      setEhInternacional(false);
    }
  }, [fornecedorIdParamentro]);

  useEffect(() => {

    setValidationSchema(
      Yup.object().shape({
        cnpj: ehInternacional
          ? Yup.string().notRequired()
          : Yup.string().required('O campo deve ser informado').test('cnpj', 'CNPJ inválido.', validarCNPJ),
        razaoSocial: Yup.string().required('O campo deve ser informado'),
      })
    );

  }, [ehInternacional]);

  const hasGetAllSasFornecedorComAvaliacoes = (fornecedorIdParamentro: string) => {
    getAllSasFornecedorPainelComAvaliacoes(fornecedorIdParamentro).then(fornecedorComAvaliacoes => {
      setFornecedorAvaliacoes(fornecedorComAvaliacoes);
      // IN0926-3093: fornecedor estrangeiro vem do TOTVS com um CGC sintético
      // (<código>+zeros) em vez de vazio, então "tem CNPJ" não significa nacional.
      setEhInternacional(!(isObjNotEmpty(fornecedorComAvaliacoes.cnpj) && validarCNPJ(fornecedorComAvaliacoes.cnpj)));
    });
  };

  const incluirAvalizacaoCondide = (fornecedorId: string, formValues: any): void => {
    formValues['sasFornecedorId'] = fornecedorId;
    createsasFornecedorAvaliacaoConfide(formValues as sasFornecedorAvaliacaoComplianceFrom).then(data => {
      if (data) {
        hasGetAllSasFornecedorComAvaliacoes(fornecedorId);
        setFecharModalSucesso(!fecharModalSucesso);
      } else {
      }
    });
  };
  const incluirAvalizacaoFinanceira = (fornecedorId: string, formValues: any): void => {
    formValues['sasFornecedorId'] = fornecedorId;
    createSasFornecedorAvaliacaoFinanceira(formValues as sasFornecedorAvaliacaoFinanceiraFrom).then(data => {
      if (data) {
        hasGetAllSasFornecedorComAvaliacoes(fornecedorId);
        setFecharModalSucesso(!fecharModalSucesso);
      } else {
      }
    });
  };

  const incluirAvalizacaoCompliace = (fornecedorId: string, formValues: any): void => {
    formValues['sasFornecedorId'] = fornecedorId;
    createsasFornecedorAvaliacaoCompliance(formValues as sasFornecedorAvaliacaoComplianceFrom).then(data => {
      if (data) {
        hasGetAllSasFornecedorComAvaliacoes(fornecedorId);
        setFecharModalSucesso(!fecharModalSucesso);
      } else {
      }
    });
  };

  const salvarFornecedor = (values: sasFornecedorFrom) => {
    values.naturezaFornecedor = ehInternacional == true ? "1" : "0";

    if (values && values.id) {
      updateFornecedorPainel(values)
        .then(result => {
          if (result && isValidGuid(result.id) && result !== true) {
            setFornecedorId(result.id);
            hasGetAllSasFornecedorComAvaliacoes(result.id);
          }
        });
    } else {
      createSasFornecedorPainel(values)
        .then(result => {
          if (result && isValidGuid(result.id) && result !== true) {
            setFornecedorId(result.id);
            hasGetAllSasFornecedorComAvaliacoes(result.id);
          }
        });
    }
  };

  const viewArquivoCompliace = async (id: string, nomeArquivo: string) => {
    viewArquivoAnexoFornecedorAvaliacaoCompliance(id, nomeArquivo);
  };
  const downloadArquivoCompliace = async (id: string, nomeArquivo: string) => {
    downloadArquivoAnexoFornecedorAvaliacaoCompliance(id, nomeArquivo);
  };

  const excluirArquivoCompliace = async (id: string, fornecedorId: string) => {
    deletesasFornecedorAvaliacaoCompliance(id).then(data => {
      hasGetAllSasFornecedorComAvaliacoes(fornecedorId);
    });
  };

  const viewArquivoFinanceira = async (id: string, nomeArquivo: string) => {
    wiewArquivoAnexoFornecedorAvaliacaoFinanceira(id, nomeArquivo);
  };
  const downloadFinanceira = async (id: string, nomeArquivo: string) => {
    downloadArquivoAnexoFornecedorAvaliacaoFinanceira(id, nomeArquivo);
  };

  const excluirArquivoFinanceira = async (id: string, fornecedorId: string) => {
    deletesasFornecedorAvaliacaoFinanceira(id).then(data => {
      hasGetAllSasFornecedorComAvaliacoes(fornecedorId);
    });
  };

  const viewArquivoConfide = async (id: string, nomeArquivo: string) => {
    wiewArquivoAnexoFornecedorAvaliacaoConfide(id, nomeArquivo);
  };
  const downloadArquivoConfide = async (id: string, nomeArquivo: string) => {
    downloadAnexoFornecedorAvaliacaoConfide(id, nomeArquivo);
  };

  const excluirArquivoConfide = async (id: string, fornecedorId: string) => {
    deletesasFornecedorAvaliacaoConfide(id).then(data => {
      hasGetAllSasFornecedorComAvaliacoes(fornecedorId);
    });
  };

  return (
    <SimpleView>
      <CompositeView>
        <GridView noform>
          <Collapse
            bordered={false}
            activeKey={'painelFinanceiroFornecedores'}
            expandIcon={() => <Icon type="arrows-right_4" />}>
            <Panel key="painelFinanceiroFornecedores" header="Painel Financeiro dos Fornecedores">
              <MasterDetailForm
                initialValues={fornecedorAvaliacoes}
                onSubmit={salvarFornecedor}
                validationSchema={validationSchema}
              >
                <FormContext.Consumer>
                  {({ formProps }) => {
                    return (
                      <Widget
                        actions={[
                          hasPermission(['SAS_FORNECEDOR_INCLUIR']) && (
                            <FormSubmitButton noIcon={true} type="primary">
                              <FormatText id="ui.commons.save" uppercase />
                            </FormSubmitButton>
                          ),
                        ]}>
                        <FormSelect
                          label="Natureza fornecedor"
                          placeholder="Natureza fornecedor"
                          options={[
                            { value: '0', text: 'Nacional' },
                            { value: '1', text: 'Internacional' },
                          ]}
                          name="naturezaFornecedor"
                          span={2}
                          onSelect={(value: any, option) => {
                            if (formProps) {
                              formProps.resetForm();
                              if (value == '1') {
                                formProps.setFieldValue("cnpj", "");
                              }
                            }
                            setEhInternacional(vtStringToBoolean(value));
                          }}
                          value={ehInternacional == true ? "1" : "0"}
                        />
                        <FormInput label="Código Totvs" name="codigoTotvs" span={2} />
                        <FormInput label="CNPJ" name="cnpj" span={3} disabled={ehInternacional} />
                        <FormInput label="Razão Social" name="razaoSocial" span={5} />
                      </Widget>
                    );
                  }}
                </FormContext.Consumer>
              </MasterDetailForm>
            </Panel>
          </Collapse>

          <Visibility
            visible={isValidGuid(fornecedorId) && isObjNotEmpty(fornecedorAvaliacoes)}
          >

            <FormularioTabelaAvaliacao
              headerPanel={'Relatório Financeiro'}
              incluir={incluirAvalizacaoCondide}
              fornecedorId={fornecedorId}
              dataSource={fornecedorAvaliacoes.sasSFornecedorAvaliacaoConfide}
              initialValues={{
                comentario: fornecedorAvaliacoes.confideComentario,
                validadeAtual: fornecedorAvaliacoes.confideFormat,
              }}
              viewArquivoAnexo={viewArquivoConfide}
              downloadArquivo={downloadArquivoConfide}
              fecharModalSucesso={fecharModalSucesso}
              excluir={excluirArquivoConfide}
            />
            <FormularioTabelaAvaliacao
              headerPanel={'Avaliação Financeira'}
              incluir={incluirAvalizacaoFinanceira}
              fornecedorId={fornecedorId}
              dataSource={fornecedorAvaliacoes.sasFornecedorAvaliacaoFinanceira}
              initialValues={{
                comentario: fornecedorAvaliacoes.financeiroComentario,
                validadeAtual: fornecedorAvaliacoes.financeiroFormat,
              }}
              viewArquivoAnexo={viewArquivoFinanceira}
              downloadArquivo={downloadFinanceira}
              fecharModalSucesso={fecharModalSucesso}
              excluir={excluirArquivoFinanceira}
            />
            <FormularioTabelaAvaliacao
              headerPanel={'Avaliação Compliance'}
              incluir={incluirAvalizacaoCompliace}
              fornecedorId={fornecedorId}
              dataSource={fornecedorAvaliacoes.sasFornecedorAvaliacaoCompliance}
              initialValues={{
                comentario: fornecedorAvaliacoes.compliaceComentario,
                validadeAtual: fornecedorAvaliacoes.compliaceFormat,
              }}
              viewArquivoAnexo={viewArquivoCompliace}
              downloadArquivo={downloadArquivoCompliace}
              fecharModalSucesso={fecharModalSucesso}
              excluir={excluirArquivoCompliace}
            />

          </Visibility>

        </GridView>
      </CompositeView>
    </SimpleView>
  );
};

export default FormFornecedor;
